import { __extends } from "tslib";
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { DisplayObject as AwayDisplayObject } from '@awayjs/scene';
//import {BitmapImage2D as BitmapData} from "@awayjs/stage"
import { XMLDocumentAway } from './customAway/xml/XMLDocumentAway';
import { AVM1Stage } from './lib/AVM1Stage';
var AVM1Movie = /** @class */ (function (_super) {
    __extends(AVM1Movie, _super);
    function AVM1Movie() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AVM1Movie.prototype._getLevelForRoot = function (root) { return 0; };
    AVM1Movie.prototype._getRootForLevel = function (level) { return null; };
    AVM1Movie.prototype._addRoot = function (level, root) { };
    AVM1Movie.prototype._removeRoot = function (level) { };
    return AVM1Movie;
}(AwayDisplayObject));
export { AVM1Movie };
var ContextMenu = /** @class */ (function () {
    function ContextMenu() {
    }
    return ContextMenu;
}());
export { ContextMenu };
var ContextMenuItem = /** @class */ (function () {
    function ContextMenuItem() {
    }
    return ContextMenuItem;
}());
export { ContextMenuItem };
var fscommand = /** @class */ (function () {
    function fscommand() {
    }
    return fscommand;
}());
export { fscommand };
var Security = /** @class */ (function () {
    function Security() {
    }
    return Security;
}());
export { Security };
var Capabilities = /** @class */ (function () {
    function Capabilities() {
    }
    return Capabilities;
}());
export { Capabilities };
var ExternalInterface = /** @class */ (function () {
    function ExternalInterface() {
    }
    return ExternalInterface;
}());
export { ExternalInterface };
var Mouse = /** @class */ (function () {
    function Mouse() {
    }
    return Mouse;
}());
export { Mouse };
var SoundChannel = /** @class */ (function () {
    function SoundChannel() {
    }
    return SoundChannel;
}());
export { SoundChannel };
var SoundTransform = /** @class */ (function () {
    function SoundTransform() {
    }
    return SoundTransform;
}());
export { SoundTransform };
var SoundMixer = /** @class */ (function () {
    function SoundMixer() {
    }
    return SoundMixer;
}());
export { SoundMixer };
var SecurityDomain = /** @class */ (function () {
    function SecurityDomain() {
        this.flash = {
            display: {
                AVM1Movie: AVM1Movie,
                Stage: AVM1Stage
            },
            events: {
                Event: Event,
                KeyboardEvent: KeyboardEvent,
                MouseEvent: MouseEvent,
                ProgressEvent: ProgressEvent
            },
            external: {
                ExternalInterface: ExternalInterface
            },
            filters: {},
            system: {
                Capabilities: Capabilities,
                Security: Security,
                fscommand: fscommand
            },
            ui: {
                ContextMenu: ContextMenu,
                ContextMenuItem: ContextMenuItem,
                Mouse: Mouse
            },
            media: {
                SoundChannel: SoundChannel,
                SoundTransform: SoundTransform,
                SoundMixer: SoundMixer
            },
            xml: {
                XMLDocument: XMLDocumentAway
            }
        };
        this.player = {}; //80pro Shumway.Player.Player;
    }
    return SecurityDomain;
}());
export { SecurityDomain };
